import { useTranslation } from 'react-i18next';
import { home as zhHome } from '@/i18n/local/zh/home';
import { home as enHome } from '@/i18n/local/en/home';
import { about as zhAbout } from '@/i18n/local/zh/about';
import { about as enAbout } from '@/i18n/local/en/about';
import { technology as zhTech } from '@/i18n/local/zh/technology';
import { technology as enTech } from '@/i18n/local/en/technology';
import { products as zhProducts } from '@/i18n/local/zh/products';
import { products as enProducts } from '@/i18n/local/en/products';
import { sustainability as zhSustain } from '@/i18n/local/zh/sustainability';
import { sustainability as enSustain } from '@/i18n/local/en/sustainability';

export function useHomeData() {
  const { i18n } = useTranslation();
  return i18n.language === 'zh' ? zhHome : enHome;
}

export function useAboutData() {
  const { i18n } = useTranslation();
  return i18n.language === 'zh' ? zhAbout : enAbout;
}

export function useTechnologyData() {
  const { i18n } = useTranslation();
  return i18n.language === 'zh' ? zhTech : enTech;
}

export function useProductsData() {
  const { i18n } = useTranslation();
  return i18n.language === 'zh' ? zhProducts : enProducts;
}

export function useSustainabilityData() {
  const { i18n } = useTranslation();
  return i18n.language === 'zh' ? zhSustain : enSustain;
}